import {useCallback} from 'react';
import {useRouter} from 'expo-router';
import {organizationRoutes} from '@/lib/routes';

export const useOrganizationNavigation = (orgId: string) => {
    const router = useRouter();

    const navigateToAchievements = useCallback(() => {
        router.push(organizationRoutes.achievements(orgId));
    }, [router, orgId]);

    const navigateToLibrary = useCallback(() => {
        router.push(organizationRoutes.library(orgId));
    }, [router, orgId]);

    const navigateToBookmarks = useCallback(() => {
        router.push(organizationRoutes.bookmarks(orgId));
    }, [router, orgId]);

    const navigateToLastViewedVideos = useCallback(() => {
        router.push(organizationRoutes.lastViewedVideos(orgId));
    }, [router, orgId]);

    const navigateToProfile = useCallback(() => {
        router.push(organizationRoutes.profile(orgId));
    }, [router, orgId]);

    const navigateToMembershipPlan = useCallback(() => {
        router.push(organizationRoutes.membershipPlan(orgId));
    }, [router, orgId]);

    const navigateToDashboard = useCallback(() => {
        router.push(organizationRoutes.dashboard(orgId));
    }, [router, orgId]);

    const navigateToOffers = useCallback(() => {
        router.push(organizationRoutes.offers(orgId));
    }, [router, orgId]);

    const navigateToChat = useCallback(() => {
        router.push(organizationRoutes.chat(orgId));
    }, [router, orgId]);

    const navigateToInvite = useCallback(() => {
        router.push(organizationRoutes.invite(orgId));
    }, [router, orgId]);

    const navigateToOfferDetail = useCallback((offerId: string) => {
        router.push(organizationRoutes.offerDetail(orgId, offerId));
    }, [router, orgId]);

    const navigateToVideo = useCallback((videoId: string, source?: string, folderId?: string) => {
        router.push(organizationRoutes.video(orgId, videoId, source, folderId));
    }, [router, orgId]);

    const navigateBack = useCallback(() => {
        if (router.canGoBack()) {
            router.back();
        } else {
            // Fallback to organization dashboard if no history
            navigateToDashboard();
        }
    }, [router, navigateToDashboard]);

    return {
        navigateToAchievements,
        navigateToLibrary,
        navigateToBookmarks,
        navigateToLastViewedVideos,
        navigateToProfile,
        navigateToMembershipPlan,
        navigateToOffers,
        navigateToChat,
        navigateToInvite,
        navigateToOfferDetail,
        navigateToDashboard,
        navigateToVideo,
        navigateBack,
        orgId
    };
};
